module.exports = __webpack_public_path__ + "static/media/IMG_1813.ad51ae2f.jpg";